import React from 'react';
import { Form } from 'react-bootstrap';

class ScenarioInput extends React.Component {
  
  renderScenarioInput(props) {
    let result;
    result = (
      <Form.Group controlId="formScenario">
        <Form.Label>Scenario</Form.Label>
        <Form.Control size="sm" type="text" {...props}/>
      </Form.Group>
    );
    return result;
  }

  render() {
    return this.renderScenarioInput(this.props);
  }
}


export default ScenarioInput;

